module.exports = __webpack_public_path__ + "img/bg.6cd7a627.png";